import { useNavigate } from "react-router-dom";

const LogoComponent = ({ inverted = false, size = 40 }) => {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate("/register")} style={{ cursor: "pointer" }}>
      <img
        src={inverted ? "assets/img/Kasper-black.png" : "assets/img/Kasper.png"}
        alt="logo"
        height={size}
        width={size}
      />
    </div>
  );
};

export default LogoComponent;
